/**
 * Support Pages — Shared JavaScript
 * Search filtering, Load More toggle, Accordion
 */

document.addEventListener('DOMContentLoaded', function () {
  initSearch();
  initLoadMore();
  initAccordions();
});

/* ---------- Search Filter ---------- */

function initSearch() {
  var searchInput = document.querySelector('.support-search__input');
  if (!searchInput) return;

  var cards = document.querySelectorAll('.support-card');
  var sections = document.querySelectorAll('.support-section[data-category]');

  searchInput.addEventListener('input', function () {
    var query = this.value.toLowerCase().trim();

    // When searching, temporarily reveal all extra cards
    var extraCards = document.querySelectorAll('.support-card--extra');
    if (query) {
      extraCards.forEach(function (card) {
        card.classList.add('is-visible');
      });
      document.querySelectorAll('.support-load-more').forEach(function (el) {
        el.style.display = 'none';
      });
    } else {
      // Restore load-more state
      extraCards.forEach(function (card) {
        var section = card.closest('.support-section');
        var btn = section ? section.querySelector('.support-load-more__btn') : null;
        if (!btn || !btn.classList.contains('is-expanded')) {
          card.classList.remove('is-visible');
        }
      });
      document.querySelectorAll('.support-load-more').forEach(function (el) {
        el.style.display = '';
      });
    }

    // Filter cards by query
    cards.forEach(function (card) {
      var title = card.querySelector('.support-card__title');
      var subtitle = card.querySelector('.support-card__subtitle');
      var titleText = title ? title.textContent.toLowerCase() : '';
      var subtitleText = subtitle ? subtitle.textContent.toLowerCase() : '';
      var match = !query || titleText.includes(query) || subtitleText.includes(query);

      if (card.classList.contains('support-card--extra')) {
        // Extra cards: toggle is-visible, plus use data attr for search hiding
        if (match && query) {
          card.classList.add('is-visible');
          card.removeAttribute('data-search-hidden');
        } else if (!match && query) {
          card.classList.remove('is-visible');
          card.setAttribute('data-search-hidden', '');
        } else {
          card.removeAttribute('data-search-hidden');
        }
      } else {
        card.style.display = match ? '' : 'none';
      }
    });

    // Hide sections with no visible cards
    sections.forEach(function (section) {
      var visibleCards = section.querySelectorAll(
        '.support-card:not(.support-card--extra):not([style*="display: none"]), .support-card--extra.is-visible:not([data-search-hidden])'
      );
      section.style.display = visibleCards.length ? '' : 'none';
    });
  });
}

/* ---------- Load More ---------- */

function initLoadMore() {
  document.querySelectorAll('.support-load-more__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var section = this.closest('.support-section');
      if (!section) return;

      var isExpanded = this.classList.contains('is-expanded');
      var extraCards = section.querySelectorAll('.support-card--extra');

      extraCards.forEach(function (card) {
        if (isExpanded) {
          card.classList.remove('is-visible');
        } else {
          card.classList.add('is-visible');
        }
      });

      this.classList.toggle('is-expanded');
      var label = this.querySelector('.support-load-more__label');
      if (label) {
        label.textContent = isExpanded ? 'Load More' : 'Show Less';
      }

      this.setAttribute('aria-expanded', String(!isExpanded));
    });
  });
}

/* ---------- Accordions ---------- */

function initAccordions() {
  document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    var trigger = accordion.querySelector('.manual-accordion__trigger');
    var content = accordion.querySelector('.manual-accordion__content');
    var icon = accordion.querySelector('.manual-accordion__icon');
    if (!trigger || !content) return;

    // Set up ARIA
    var contentId = content.id || 'accordion-content-' + Math.random().toString(36).substr(2, 9);
    var triggerId = trigger.id || 'accordion-trigger-' + Math.random().toString(36).substr(2, 9);
    content.id = contentId;
    trigger.id = triggerId;
    trigger.setAttribute('aria-controls', contentId);
    content.setAttribute('role', 'region');
    content.setAttribute('aria-labelledby', triggerId);

    // Default: open
    content.style.maxHeight = content.scrollHeight + 'px';
    accordion.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');

    trigger.addEventListener('click', function () {
      var isOpen = accordion.classList.contains('is-open');

      if (isOpen) {
        content.style.maxHeight = '0px';
        if (icon) icon.textContent = '+';
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        if (icon) icon.textContent = '\u2212';
        trigger.setAttribute('aria-expanded', 'true');
      }

      accordion.classList.toggle('is-open');
    });
  });
}
